import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RelatiesviewComponent } from './relaties/relatiesview/relatiesview.component';
import { AuthGuardService } from "./shared/auth/AuthGuardService";
import { AuthLogoutService } from "./shared/auth/AuthLogoutService";
import { AuthRegisterService } from "./shared/auth/AuthRegisterService";
import { GetTokenComponent } from './get-token/get-token.component';
import { FactuurViewComponent } from './factuur/factuur-view/factuur-view.component';
import { OffertetableComponent } from './offerte/offertetable/offertetable.component';
import { ObjectentableComponent } from './objecten/objectentable/objectentable.component';
import { ObjectComponent} from './objecten/object/object.component';
import { RelatieEditComponent } from './relaties/relatie-edit/relatie-edit.component';
import { ContactpersoneneditComponent } from './relaties/contactpersonen/contactpersonenedit/contactpersonenedit.component';
import { RelatieAddComponent } from './relaties/relatie-add/relatie-add.component';
import { ObjectAddComponent } from './objecten/object-add/object-add.component';
import { OfferteViewComponent } from './offerte/offerte-view/offerte-view.component';
import { FactuurEditComponent } from './factuur/edit/factuur-edit/factuur-edit.component';
import { OfferteEditComponent } from './offerte/edit/offerte-edit/offerte-edit.component';
import { ObjectEditComponent } from './objecten/object-edit/object-edit.component';
import { AuthComponent } from './auth/auth.component';
import { LoginServiceService } from './shared/auth/login-service.service';
import { HomeComponent } from './home/home.component';
import { StatusOverzichtFilterComponent } from './objecten/status-overzicht/status-overzicht-filter/status-overzicht-filter.component';
import { StatusOverzichtObjectComponent } from './objecten/status-overzicht/status-overzicht-object/status-overzicht-object.component';
import { StatusOverzichtSelectComponent } from './objecten/status-overzicht/leverancier/status-overzicht-select/status-overzicht-select.component';


const routes: Routes = [
  { path: 'relaties', component: RelatiesviewComponent, canActivate: [AuthGuardService] },
  { path: 'relaties/add', component: RelatieAddComponent, canActivate: [AuthGuardService] },
  { path: 'relaties/:id',      component: RelatieEditComponent, canActivate: [AuthGuardService] },
  { path: 'contactpersonen/:id',      component: ContactpersoneneditComponent, canActivate: [AuthGuardService] },
  { path: 'contactpersoontoevoegen/:relatieid',      component: ContactpersoneneditComponent, canActivate: [AuthGuardService] },
  { path: 'factuur', component: FactuurViewComponent,
    canActivate: [AuthGuardService]
  },
  { path: 'factuur/:id', component: FactuurEditComponent,
    canActivate: [AuthGuardService]
  },
  { path: 'offerte/:id', component: OfferteEditComponent,
    canActivate: [AuthGuardService]
  },
  { path: 'offerte', component: OfferteViewComponent,
    canActivate: [AuthGuardService]
  },
  { path: 'objecten/add', component: ObjectAddComponent, canActivate: [AuthGuardService] },
  { path: 'objecten/:id', component: ObjectEditComponent,
    canActivate: [AuthGuardService]
  },
  { path: 'objecten/:id', component: ObjectEditComponent,
    canActivate: [AuthGuardService]
  },
  { path: 'objecten', component: ObjectComponent,
    canActivate: [AuthGuardService]
  },
  { path: 'objecten/statusrapport/:id', component: StatusOverzichtObjectComponent,
    canActivate: [AuthGuardService]
  },
  {
    path:'statusview',component: StatusOverzichtFilterComponent,canActivate: [AuthGuardService]
  },
  {
    path:'statusleverancier',component: StatusOverzichtSelectComponent,canActivate: [AuthGuardService]
  },
  { path: 'authenticated', component: GetTokenComponent,
    canActivate: [AuthRegisterService]
  },
  { path: 'auth', component: AuthComponent,
  },
  { path: 'logout', component: HomeComponent,
    canActivate: [AuthLogoutService]
  },
  { path: 'login', component: HomeComponent,
    canActivate: [LoginServiceService]
  },
  { path: '', component: HomeComponent, canActivate: [AuthGuardService]},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
